export default __webpack_public_path__ + "static/media/arena_4.18fa2f00.jpeg";